import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { initialize } from 'redux-form';
import { editContract } from 'redux/modules/newContract';
import { NewContractForm, PageHeader } from 'components';
import { AppLayout } from 'containers';
var NewContract = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    contract: state.contract
  };
}, {
  initialize: initialize,
  editContract: editContract
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(NewContract, _Component);

  var _super = _createSuper(NewContract);

  function NewContract() {
    var _this;

    _classCallCheck(this, NewContract);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var c = _this.props.contract;

      _this.props.initialize('newContract', {
        uuid: c.uuid,
        sfid: c.crmUrl,
        firstName: c.firstName,
        lastName: c.lastName,
        contractStartsAt: c.contractStartsAt,
        email: c.email,
        address_id: c.Address.id,
        address1: c.Address.address1,
        address2: c.Address.address2,
        region: c.Address.region,
        locality: c.Address.locality,
        postcode: c.Address.postcode,
        country: c.Address.country,
        Product: {
          id: c.Products[0].id
        },
        paymentMethod: {
          id: c.paymentMethodId
        },
        quantity: c.Products[0].ContractProduct.quantity,
        contractMonths: c.Products[0].ContractProduct.contractMonths,
        setupFee: c.Products[0].ContractProduct.setupFee,
        monthlyFee: c.Products[0].ContractProduct.monthlyFee
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (data) {
      _this.props.editContract(data).then(function (savedcontract) {
        console.dir(savedcontract);

        _this.context.router.push("/customeragreement/teamview/".concat(savedcontract.data.uuid));
      });
    });

    return _this;
  }

  _createClass(NewContract, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AppLayout, {
        params: _objectSpread({}, this.props.params)
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Edit Customer Agreement"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Edit A Customer Agreement"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(NewContractForm, {
        onSubmit: this.handleSubmit,
        isEdit: true
      })));
    }
  }]);

  return NewContract;
}(Component), _defineProperty(_class2, "propTypes", {
  initialize: PropTypes.func.isRequired,
  editContract: PropTypes.func.isRequired,
  contract: PropTypes.object.isRequired
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class);
export { NewContract as default };